import React, { useState } from "react"; // Hapus useEffect
import { auth } from "../firebase"; // Import konfigurasi Firebase
import { sendPasswordResetEmail } from "firebase/auth";
import { FaKey } from "react-icons/fa";
import { toast } from "react-toastify"; // Untuk menampilkan notifikasi

const Profile = () => {
    const user = auth.currentUser;
    const email = user?.email || "";
    const uid = user?.uid || ""; // Ambil user ID

    const [message, setMessage] = useState(""); // Pesan notifikasi

    // Fungsi untuk mereset password
    const handleResetPassword = async () => {
        try {
            await sendPasswordResetEmail(auth, email); // Kirim email reset password
            setMessage("Email untuk mereset password telah dikirim!");
        } catch (error) {
            setMessage(
                "Gagal mengirim email reset password. Periksa kembali email Anda."
            );
        }
    };

    // Fungsi untuk menyalin UID ke clipboard
    const handleCopyUID = () => {
        navigator.clipboard.writeText(uid); // Salin UID ke clipboard
        toast.success("UID berhasil disalin!");
    };

    return (
        <div className="container mx-auto p-6">
            <h1 className="text-2xl font-bold mb-6">Profil Saya</h1>
            <div className="space-y-4">
                {/* Menampilkan User ID */}
                <div className="form-control">
                    <label className="label">User ID</label>
                    <input
                        type="text"
                        value={uid}
                        readOnly
                        onClick={handleCopyUID} // Salin UID ketika diklik
                        className="input input-bordered w-full bg-gray-100 cursor-pointer"
                    />
                </div>

                {/* Menampilkan Email */}
                <div className="form-control">
                    <label className="label">Email</label>
                    <input
                        type="email"
                        value={email}
                        readOnly
                        className="input input-bordered w-full bg-gray-100"
                    />
                </div>

                {/* Tombol Reset Password */}
                <button
                    type="button"
                    className="btn btn-primary mt-4 flex items-center gap-2"
                    onClick={handleResetPassword}
                >
                    <FaKey /> Reset Password
                </button>

                {/* Menampilkan Pesan */}
                {message && <p className="text-green-500 mt-2">{message}</p>}
            </div>
        </div>
    );
};

export default Profile;
